export default __webpack_public_path__ + "static/media/5.605b6a7d.mp4";